// Helper to get default equipment image based on type
export const getDefaultImage = (job) => {
  // Check both equipmentType and item name for the type
  const type = (job?.equipmentType || job?.item || '').toLowerCase();
  const category = job?.category?.toLowerCase() || '';
  
  // Check specific equipment types - be careful with order!
  // Fire extinguisher first (most specific)
  if (type.includes('fire extinguisher')) return '/images/maintenance/specific/fire-extinguisher.jpg';
  // Check for foam vs inflatable lifejackets
  if (type.includes('foam') && (type.includes('lifejacket') || type.includes('life jacket'))) {
    return '/images/maintenance/specific/foam-lifejacket.jpg';
  }
  if (type.includes('inflatable') && (type.includes('lifejacket') || type.includes('life jacket'))) {
    return '/images/maintenance/specific/inflatable-lifejacket.jpg';
  }
  // Default lifejacket (use inflatable if not specified)
  if (type.includes('lifejacket') || type.includes('life jacket')) return '/images/maintenance/specific/inflatable-lifejacket.jpg';
  // Liferaft 
  if (type.includes('liferaft') || type.includes('life raft')) return '/images/maintenance/specific/liferaft.jpg';
  // Lifebuoy - now we have the correct image!
  if (type.includes('lifebuoy')) return '/images/maintenance/specific/lifebuoy.jpg';
  // First aid
  if (type.includes('first aid')) return '/images/maintenance/specific/first-aid-kit.jpg';
  
  // Fall back to category images
  const categoryImages = {
    lsa: '/images/maintenance/categories/lsa.jpg',
    ffe: '/images/maintenance/categories/ffe.jpg',
    radio: '/images/maintenance/categories/radio.jpg',
    navigation: '/images/maintenance/categories/navigation.jpg',
    machinery: '/images/maintenance/categories/machinery.jpg',
    electrical: '/images/maintenance/categories/electrical.jpg',
    medical: '/images/maintenance/categories/medical.jpg',
    surveys: '/images/maintenance/categories/surveys.jpg',
    special_ops: '/images/maintenance/categories/special-ops.jpg'
  };
  
  return categoryImages[category] || '/images/maintenance/categories/default.jpg';
};